import React from "react";
import "./SummaryCard.css";

const SummaryCard = ({ title, buttonText, stats = [] }) => {
  return (
    <div className="summary-card">
      <div className="summary-header">
        <h6>{title}</h6>
        {buttonText && <button className="summary-btn">{buttonText}</button>}
      </div>

      <div className="summary-grid">
        {stats.map((item, index) => (
          <div key={index} className="summary-item">
            <p className="label">{item.label}</p>
            <h5 className="value">{item.value}</h5>
            <small className="count">{item.count}</small>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummaryCard;